import _createForOfIteratorHelper from "/Users/tauseeq/PycharmProjects/jsonvisualizer/my-app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import { EditorSelection } from '@codemirror/state';
/**
Comment or uncomment the current selection. Will use line comments
if available, otherwise falling back to block comments.
*/

var toggleComment = function toggleComment(target) {
  var config = getConfig(target.state);
  return config.line ? toggleLineComment(target) : config.block ? toggleBlockComment(target) : false;
};

function command(f, option) {
  return function (_ref) {
    var state = _ref.state,
        dispatch = _ref.dispatch;
    var tr = f(option, state.selection.ranges, state);
    if (!tr) return false;
    dispatch(state.update(tr));
    return true;
  };
}
/**
Comment or uncomment the current selection using line comments.
The line comment syntax is taken from the
[`commentTokens`](https://codemirror.net/6/docs/ref/#comment.CommentTokens) [language
data](https://codemirror.net/6/docs/ref/#state.EditorState.languageDataAt).
*/


var toggleLineComment = /*@__PURE__*/command(changeLineComment, 0
/* Toggle */
);
/**
Comment the current selection using line comments.
*/

var lineComment = /*@__PURE__*/command(changeLineComment, 1
/* Comment */
);
/**
Uncomment the current selection using line comments.
*/

var lineUncomment = /*@__PURE__*/command(changeLineComment, 2
/* Uncomment */
);
/**
Comment or uncomment the current selection using block comments.
The block comment syntax is taken from the
[`commentTokens`](https://codemirror.net/6/docs/ref/#comment.CommentTokens) [language
data](https://codemirror.net/6/docs/ref/#state.EditorState.languageDataAt).
*/

var toggleBlockComment = /*@__PURE__*/command(changeBlockComment, 0
/* Toggle */
);
/**
Comment the current selection using block comments.
*/

var blockComment = /*@__PURE__*/command(changeBlockComment, 1
/* Comment */
);
/**
Uncomment the current selection using block comments.
*/

var blockUncomment = /*@__PURE__*/command(changeBlockComment, 2
/* Uncomment */
);
/**
Default key bindings for this package.

 - Ctrl-/ (Cmd-/ on macOS): [`toggleComment`](https://codemirror.net/6/docs/ref/#comment.toggleComment).
 - Shift-Alt-a: [`toggleBlockComment`](https://codemirror.net/6/docs/ref/#comment.toggleBlockComment).
*/

var commentKeymap = [{
  key: "Mod-/",
  run: toggleComment
}, {
  key: "Alt-A",
  run: toggleBlockComment
}];

function getConfig(state) {
  var pos = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : state.selection.main.head;
  var data = state.languageDataAt("commentTokens", pos);
  return data.length ? data[0] : {};
}

var SearchMargin = 50;
/**
Determines if the given range is block-commented in the given
state.
*/

function findBlockComment(state, _ref2, from, to) {
  var open = _ref2.open,
      close = _ref2.close;
  var textBefore = state.sliceDoc(from - SearchMargin, from);
  var textAfter = state.sliceDoc(to, to + SearchMargin);
  var spaceBefore = /\s*$/.exec(textBefore)[0].length,
      spaceAfter = /^\s*/.exec(textAfter)[0].length;
  var beforeOff = textBefore.length - spaceBefore;

  if (textBefore.slice(beforeOff - open.length, beforeOff) == open && textAfter.slice(spaceAfter, spaceAfter + close.length) == close) {
    return {
      open: {
        pos: from - spaceBefore,
        margin: spaceBefore && 1
      },
      close: {
        pos: to + spaceAfter,
        margin: spaceAfter && 1
      }
    };
  }

  var startText, endText;

  if (to - from <= 2 * SearchMargin) {
    startText = endText = state.sliceDoc(from, to);
  } else {
    startText = state.sliceDoc(from, from + SearchMargin);
    endText = state.sliceDoc(to - SearchMargin, to);
  }

  var startSpace = /^\s*/.exec(startText)[0].length,
      endSpace = /\s*$/.exec(endText)[0].length;
  var endOff = endText.length - endSpace - close.length;

  if (startText.slice(startSpace, startSpace + open.length) == open && endText.slice(endOff, endOff + close.length) == close) {
    return {
      open: {
        pos: from + startSpace + open.length,
        margin: /\s/.test(startText.charAt(startSpace + open.length)) ? 1 : 0
      },
      close: {
        pos: to - endSpace - close.length,
        margin: /\s/.test(endText.charAt(endOff - 1)) ? 1 : 0
      }
    };
  }

  return null;
} // Performs toggle, comment and uncomment of block comments in
// languages that support them.


function changeBlockComment(option, ranges, state) {
  var tokens = ranges.map(function (r) {
    return getConfig(state, r.from).block;
  });
  if (!tokens.every(function (c) {
    return c;
  })) return null;
  var comments = ranges.map(function (r, i) {
    return findBlockComment(state, tokens[i], r.from, r.to);
  });

  if (option != 2
  /* Uncomment */
  && !comments.every(function (c) {
    return c;
  })) {
    var index = 0;
    return state.changeByRange(function (range) {
      var _tokens$index = tokens[index++],
          open = _tokens$index.open,
          close = _tokens$index.close;
      if (comments[index]) return {
        range: range
      };
      var shift = open.length + 1;
      return {
        changes: [{
          from: range.from,
          insert: open + " "
        }, {
          from: range.to,
          insert: " " + close
        }],
        range: EditorSelection.range(range.anchor + shift, range.head + shift)
      };
    });
  } else if (option != 1
  /* Comment */
  && comments.some(function (c) {
    return c;
  })) {
    var changes = [];

    for (var i = 0, comment; i < comments.length; i++) {
      if (comment = comments[i]) {
        var token = tokens[i],
            _comment = comment,
            open = _comment.open,
            close = _comment.close;
        changes.push({
          from: open.pos - token.open.length,
          to: open.pos + open.margin
        }, {
          from: close.pos - close.margin,
          to: close.pos + token.close.length
        });
      }
    }

    return {
      changes: changes
    };
  }

  return null;
} // Performs toggle, comment and uncomment of line comments.


function changeLineComment(option, ranges, state) {
  var lines = [];
  var prevLine = -1;

  var _iterator = _createForOfIteratorHelper(ranges),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _step$value = _step.value,
          _from = _step$value.from,
          _to = _step$value.to;
      var startI = lines.length,
          minIndent = 1e9;

      for (var pos = _from; pos <= _to;) {
        var _line2 = state.doc.lineAt(pos);

        if (_line2.from > prevLine && (_from == _to || _to > _line2.from)) {
          prevLine = _line2.from;
          var _token2 = getConfig(state, pos).line;
          if (!_token2) continue;
          var _indent = /^\s*/.exec(_line2.text)[0].length;

          var _empty = _indent == _line2.length;

          var _comment2 = _line2.text.slice(_indent, _indent + _token2.length) == _token2 ? _indent : -1;

          if (_indent < _line2.text.length && _indent < minIndent) minIndent = _indent;
          lines.push({
            line: _line2,
            comment: _comment2,
            token: _token2,
            indent: _indent,
            empty: _empty,
            single: false
          });
        }

        pos = _line2.to + 1;
      }

      if (minIndent < 1e9) for (var i = startI; i < lines.length; i++) {
        if (lines[i].indent < lines[i].line.text.length) lines[i].indent = minIndent;
      }
      if (lines.length == startI + 1) lines[startI].single = true;
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  if (option != 2
  /* Uncomment */
  && lines.some(function (l) {
    return l.comment < 0 && (!l.empty || l.single);
  })) {
    var changes = [];

    var _iterator2 = _createForOfIteratorHelper(lines),
        _step2;

    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var _step2$value = _step2.value,
            line = _step2$value.line,
            token = _step2$value.token,
            indent = _step2$value.indent,
            empty = _step2$value.empty,
            single = _step2$value.single;
        if (single || !empty) changes.push({
          from: line.from + indent,
          insert: token + " "
        });
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }

    var changeSet = state.changes(changes);
    return {
      changes: changeSet,
      selection: state.selection.map(changeSet, 1)
    };
  } else if (option != 1
  /* Comment */
  && lines.some(function (l) {
    return l.comment >= 0;
  })) {
    var _changes = [];

    var _iterator3 = _createForOfIteratorHelper(lines),
        _step3;

    try {
      for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
        var _step3$value = _step3.value,
            _line = _step3$value.line,
            comment = _step3$value.comment,
            _token = _step3$value.token;

        if (comment >= 0) {
          var from = _line.from + comment,
              to = from + _token.length;
          if (_line.text[to - _line.from] == " ") to++;

          _changes.push({
            from: from,
            to: to
          });
        }
      }
    } catch (err) {
      _iterator3.e(err);
    } finally {
      _iterator3.f();
    }

    return {
      changes: _changes
    };
  }

  return null;
}

export { blockComment, blockUncomment, commentKeymap, lineComment, lineUncomment, toggleBlockComment, toggleComment, toggleLineComment };